import { Flex, Spinner } from "@chakra-ui/react";

export default function Loader() {
  return (
    <Flex
      bg="white"
      w="100vw"
      h="100vh"
      pos="absolute"
      top="0"
      left="0"
      zIndex={20}
      align="center"
      justify="center"
    >
      <Spinner size="lg" />
    </Flex>
  );
}